import React from "react";

import {WideContent} from "@pg-design/grid-module";
import {mt} from "@pg-design/helpers-css";
import {isEqual} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {useGetOfferListModularHouses} from "../../../../modular_houses/hooks/use_get_modular_house_offer_list";
import {EmptyList} from "../../../atoms/EmptyList";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {IOfferListListStore} from "../../reducers/desktop_offer_list_list_reducer";
import {OfferListSubType} from "../../types/OfferListSubType";
import {ArchivedOffersListing} from "./listing_variants/ArchivedOffersListing";
import {DefaultOfferListing} from "./listing_variants/DefaultOfferListing";
import {SoonFinishedOffersListing} from "./listing_variants/SoonFinishedOffersListing";

interface IProps {
    ref?: React.MutableRefObject<HTMLDivElement | null>;
    list: IOfferListListStore;
    metaDataTitle: string;
    selectedRegion: ISelectedRegion[];
    className?: string;
    offerListSubType?: OfferListSubType;
}

export const OfferListListSection = React.memo(
    React.forwardRef<HTMLDivElement, IProps>((props, ref) => {
        const {count, offers, page, sold_offers, soon_finished_offers, sold_offers_count, sold_offers_page, requestState, latestQuery} = props.list;
        const currentPage = sold_offers_count ? page + sold_offers_page - 1 : page;
        const modularHouseOffers = useGetOfferListModularHouses();
        const offersCount = (modularHouseOffers.modularHouseOffers ? modularHouseOffers.modularHouseOffers.count : 0) + count;
        const isFilteredByFinishedConstruction = latestQuery.construction_end_date === "0";
        const hasNoSelectedOffersToShow = offers.length === 0;
        const hasOffersThatWillBeSoonFinishedToShow = soon_finished_offers.length > 0;

        const renderOfferListVariant = () => {
            const hasRequestSucceed = requestState === RequestState.Success;

            // When there are offers to be shown that user has requested or list is still loading
            if (offersCount) {
                return (
                    <DefaultOfferListing
                        list={props.list}
                        metaDataTitle={props.metaDataTitle}
                        selectedRegion={props.selectedRegion}
                        offerListSubType={props.offerListSubType}
                    />
                );
            }

            // When user requested offers that have been constructed, yet we have nothing to show. Show offers that soon will be finished
            if (isFilteredByFinishedConstruction && hasNoSelectedOffersToShow && hasOffersThatWillBeSoonFinishedToShow && hasRequestSucceed) {
                return <SoonFinishedOffersListing offers={soon_finished_offers} dividerVisible />;
            }

            // When there are no items user wanted to show. But we can still show some sold already items
            if (!offersCount && sold_offers_count && hasRequestSucceed) {
                return (
                    <>
                        <WideContent>
                            <EmptyList css={mt(5)} useHeader />
                        </WideContent>
                        <ArchivedOffersListing offers={sold_offers} dividerVisible={currentPage === 1} />
                    </>
                );
            }

            // When there is nothing we can show, render after fetch finished
            if (hasRequestSucceed) {
                return (
                    <WideContent>
                        <EmptyList css={mt(5)} useHeader />
                    </WideContent>
                );
            }
        };

        return (
            <div className={props.className} ref={ref}>
                {renderOfferListVariant()}
            </div>
        );
    }),
    isEqual
);
import React from "react";

import {WideContent} from "@pg-design/grid-module";
import {mt} from "@pg-design/helpers-css";
import {isEqual} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {useGetOfferListModularHouses} from "../../../../modular_houses/hooks/use_get_modular_house_offer_list";
import {EmptyList} from "../../../atoms/EmptyList";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {IOfferListListStore} from "../../reducers/desktop_offer_list_list_reducer";
import {OfferListSubType} from "../../types/OfferListSubType";
import {ArchivedOffersListing} from "./listing_variants/ArchivedOffersListing";
import {DefaultOfferListing} from "./listing_variants/DefaultOfferListing";
import {SoonFinishedOffersListing} from "./listing_variants/SoonFinishedOffersListing";

interface IProps {
    ref?: React.MutableRefObject<HTMLDivElement | null>;
    list: IOfferListListStore;
    metaDataTitle: string;
    selectedRegion: ISelectedRegion[];
    className?: string;
    offerListSubType?: OfferListSubType;
}

export const OfferListListSection = React.memo(
    React.forwardRef<HTMLDivElement, IProps>((props, ref) => {
        const {count, offers, page, sold_offers, soon_finished_offers, sold_offers_count, sold_offers_page, requestState, latestQuery} = props.list;
        const currentPage = sold_offers_count ? page + sold_offers_page - 1 : page;
        const modularHouseOffers = useGetOfferListModularHouses();
        const offersCount = (modularHouseOffers.modularHouseOffers ? modularHouseOffers.modularHouseOffers.count : 0) + count;
        const isFilteredByFinishedConstruction = latestQuery.construction_end_date === "0";
        const hasNoSelectedOffersToShow = offers.length === 0;
        const hasOffersThatWillBeSoonFinishedToShow = soon_finished_offers.length > 0;

        const renderOfferListVariant = () => {
            const hasRequestSucceed = requestState === RequestState.Success;

            // When there are offers to be shown that user has requested or list is still loading
            if (offersCount) {
                return (
                    <DefaultOfferListing
                        list={props.list}
                        metaDataTitle={props.metaDataTitle}
                        selectedRegion={props.selectedRegion}
                        offerListSubType={props.offerListSubType}
                    />
                );
            }

            // When user requested offers that have been constructed, yet we have nothing to show. Show offers that soon will be finished
            if (isFilteredByFinishedConstruction && hasNoSelectedOffersToShow && hasOffersThatWillBeSoonFinishedToShow && hasRequestSucceed) {
                return <SoonFinishedOffersListing offers={soon_finished_offers} dividerVisible />;
            }

            // When there are no items user wanted to show. But we can still show some sold already items
            if (!offersCount && sold_offers_count && hasRequestSucceed) {
                return (
                    <>
                        <WideContent>
                            <EmptyList css={mt(5)} useHeader />
                        </WideContent>
                        <ArchivedOffersListing offers={sold_offers} dividerVisible={currentPage === 1} />
                    </>
                );
            }

            // When there is nothing we can show, render after fetch finished
            if (hasRequestSucceed) {
                return (
                    <WideContent>
                        <EmptyList css={mt(5)} useHeader />
                    </WideContent>
                );
            }
        };

        return (
            <div className={props.className} ref={ref}>
                {renderOfferListVariant()}
            </div>
        );
    }),
    isEqual
);
